export default __webpack_public_path__ + "static/media/sampleTransactions.7bf7ab01.csv";